module.exports = __webpack_public_path__ + "media/dashboard/assets/images/background_rect-46c505b565c2103246bea67ca7e20f60.png";